import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import React, { useImperativeHandle, useState } from "react";
import { CurrencyFormat } from "../../../components/FormattersTS";
import { Spin } from "antd";
import HelpLabel from "../../../components/HelpLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
const OnDemandEarningsWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        loadOnDemandEarnings();
    };
    const loadOnDemandEarnings = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/on-demand-earnings/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(error => {
            setStateData(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const { totalCalcPaymentAmount } = stateData ?? {};
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-dk-blue", children: _jsx(FontAwesomeIcon, { icon: faTruck }) }), totalCalcPaymentAmount
                    ? _jsx("h2", { className: "widget-value", children: _jsx(CurrencyFormat, { value: totalCalcPaymentAmount, roundToDollars: true }) })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "On Demand earnings", helpText: _jsx("p", { children: "The amount you will earn from performing on demand marketplace deliveries. If you are performing any pay by the tonne deliveries then this final value may change based on the net tonnes delivered." }) }) })] }) }));
};
export default React.forwardRef(OnDemandEarningsWidget);
